import axiosService from 'src/services/axiosService';
import routes from 'src/config/api.routes';

class LocationsService {
  GetCountries = async () => axiosService.get(routes.countries);

  GetRegions = async () => axiosService.get(routes.regions);

  GetRegionsByCountry = async countryId => axiosService.get(`${routes.regions}/countryCode/${countryId}`);

  GetCities = async () => axiosService.get(routes.cities);

  GetCitiesByRegion = async regionId => axiosService.get(`${routes.cities}/regionCode/${regionId}`);
}

const locationsService = new LocationsService();
export default locationsService;
